var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"__total-data"},[_vm._v(" "+_vm._s(_vm.$t('global.text.displays'))+" "),_c('strong',[_vm._v(_vm._s(_vm.totalCount))]),_vm._v(" "+_vm._s(_vm.$t('global.text.data'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }